import { OperationAuditModel } from '../operation-audit-model';

export class MicrosoftOfficeOperationStopAuditContextModel extends OperationAuditModel {
}
